export default "/certificate";
